import React from "react";
import PropTypes from "prop-types";
import "clockpicker/dist/jquery-clockpicker.min";
import "clockpicker/dist/jquery-clockpicker.min.css";

@autobind
/**
 *
 */
export default class TimePicker extends React.PureComponent {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    max: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.oneOf([false]),
    ]),
    name: PropTypes.string,
  };

  static defaultProps = {
    max: 23,
    name: "TimePicker",
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      input: props.value ? props.value.replace(/( )/g, "").replace(/(:)/g, " : ").slice(0, 7) : "",
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { max, onChange, name } = this.props;

    if (max !== false && max < 24) {
      $(this.clockPicker).clockpicker({
        autoclose: true,
      }).change((e) => {
        if (name !== "TimePicker") {
          // eslint-disable-next-line
          onChange(e.target.value ? e.target.value.replace(/ /g, "") : e.target.value, name);
        } else {
          // eslint-disable-next-line
          onChange(e.target.value ? e.target.value.replace(/ /g, "") : e.target.value);
        }
        this.setState({input: e.target.value});
      });
    }
  }

  /**
   *
   * @param {Object} nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        input: nextProps.value ? nextProps.value.replace(/( )/g, "").replace(/(:)/g, " : ").slice(0, 7) : "",
      });
    }
  }

  /**
   *
   * @param  {String} value
   * @param  {Number} [max=this.props.max]
   * @return {String}
   * @static
   */
  _check(value, max = this.props.max) {
    const _max = sprintf("%02s", max);

    if (max && value > _max) return _max;

    if (value < 0) return 0;

    return value;
  }

  /**
   *
   * @param {String} value
   */
  _onChange(value) {
    const { onChange, name } = this.props;
    let input = value;

    if (/\D:$/.test(input)) input = input.substr(0, input.length - 3);

    const values = input.split(":")
      .map((value) => value.replace(/\D/g, ""));

    let output = "";

    if (values.length === 2) {
      output = this._check(values[0]);
      output = `${output} : ${this._check(values[1], 59)}`;
    } else if (values[0]) {
      output = values[0];
      if (values[0].length === 2) {
        output = this._check(output);
        output = `${output} : `;
      }
    }

    output = output.slice(0, 7);

    this.setState({ input: output }, () => {
      if (output.length === 7) {
        const _value = output.replace(/ /g, "");

        if (_value !== this.props.value) {
          if (name !== "TimePicker") {
            onChange(_value, name);
          } else {
            onChange(_value);
          }
        }
      } else if (app._.isEmpty(output)) {
        if (name !== "TimePicker") {
          onChange(null, name);
        } else {
          onChange(null);
        }
      }
    });
  }

  /**
   *
   * @param {String} value
   * @private
   */
  _onBlur(value) {
    let string = "00 : 00";
    if (value.length < 2) value = `0${value}`;

    string = string.slice(value.length, string.length);

    this._onChange(`${value}${string}`);
  }

  /**
   *
   * @return {XML}
   */
  render() {
    return (
      <input
        {...this.props}
        ref={(input) => this.clockPicker = input}
        dir="ltr"
        type="text"
        className="ant-input ant-input-lg"
        value={this.state.input}
        onChange={(event) => this._onChange(app.transform.fa2en(event.target.value))}
        onBlur={(event) => this._onBlur(app.transform.fa2en(event.target.value))}
      />
    );
  }
}
